// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FGFv","textarea":"styles_textarea__NkAXg"};